import { useDispatch, useSelector } from 'react-redux'
import { setLocal } from '../../../../../../redux/action/local'
import props from '../../../../../../redux/props'
import Input from '../../../../../UI/Input/Input'

const NumberOfPitches = ({ payload, widthInPercent }) => {
  const translations = useSelector((state) => state.translations)
  const newObject = useSelector((state) => state.OBJECT)
  const dispatch = useDispatch()

  const update = (key) => (value) => {
    // dispatch(setNewObject({ ...newObject, pitches: { ...newObject.pitches, [key]: value } }))
    dispatch(setLocal(props.OBJECT, { ...newObject, pitches: { ...newObject.pitches, [key]: value } }))
  }

  return (
    <div className="wrapper" style={{ width: `${widthInPercent}%` }}>
      <div className="group">
        <div className="label">{translations['object.pitches.number']}</div>
        <div className="values">
          <Input type="number" value={newObject.pitches.garage} onChange={update('garage')} placeholder={translations['object.pitches.garage']} />
          <Input type="number" value={newObject.pitches.outdoor} onChange={update('outdoor')} placeholder={translations['object.pitches.outdoor']} />
          <Input type="number" value={newObject.pitches.underground} onChange={update('underground')} placeholder={translations['object.pitches.underground']} />
        </div>
      </div>
    </div>
  )
}

export default NumberOfPitches
